import React from 'react'

export default function FiveStars({className, fill = '#fff'}) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 500.2 91" fill={fill} className={className}>
      <path d="m46 0 10 35h35L63 56l11 35-28-21-29 21 11-35L0 35h35zM148 0l11 35h34l-28 21 11 35-28-21-28 21 10-35-28-21h35zM250 0l11 35h35l-28 21 10 35-28-21-28 21 11-35-28-21h34zM352 0l11 35h35l-28 21 11 35-29-21-28 21 11-35-28-21h34zM455 0l10 35h35l-28 21 11 35-28-21-29 21 11-35-28-21h35z" />
    </svg>
  )
}
